export default __webpack_public_path__ + "assets/images/decor_small.8a4bb6.png";